export default __webpack_public_path__ + "media/images/images/gallery/41-2093422d5ac7def588cdae62969a2189.png";